import { combineReducers } from '@reduxjs/toolkit';
import vehiclePriceReducer from './reducers/vehicleprice';
import vehicleSearchParamsReducer from './reducers/vehiclesearchparams';
import layoutReducer from './reducers/layout';
import vehicleImageGalleryReducer from './reducers/vehicleimagegallery';
import selectedOptionsReducer from './reducers/selectedoptions';
import vehicleColourOptionsReducer from './reducers/vehiclecolouroptions';
import vehicleInformationReducer from './reducers/vehicleinformation';
import tabsReducer from './reducers/tabs';
import vehicleExteriorReducer from './reducers/vehicleexterior';
import vehicleInteriorReducer from './reducers/vehicleinterior';
import vehicleConfiguration from './reducers/vehicleconfiguration';
import pricingOptions from './reducers/pricingoptions';
import finalisedOptionsReducer from './reducers/finalisedoptions';
import navigateReducer from './reducers/navigate';
import pricingStateReducer from './reducers/pricingState';

export const reducers = combineReducers({
  vehiclePrice: vehiclePriceReducer,
  vehicleSearchParams: vehicleSearchParamsReducer,
  layout: layoutReducer,
  vehicleImageGallery: vehicleImageGalleryReducer,
  selectedOptions: selectedOptionsReducer,
  vehicleColourOptions: vehicleColourOptionsReducer,
  vehicleInformation: vehicleInformationReducer,
  tabs: tabsReducer,
  vehicleExterior: vehicleExteriorReducer,
  vehicleInterior: vehicleInteriorReducer,
  vehicleConfiguration: vehicleConfiguration,
  pricingOptions: pricingOptions,
  finalisedOptions: finalisedOptionsReducer,
  navigate: navigateReducer,
  pricingState: pricingStateReducer,
});
